export const GDPR_COOKIE_NAME = 'cfGdpr'
